import { faqPagesBodySchema } from "@redotech/redo-support-common/faq/faq-body-schema";
import * as z from "zod";

export const getFaqPages = {
  name: "getFaqPages" as const,
  input: z.object({}),
  output: z.object({ pages: z.array(faqPagesBodySchema) }),
};
